import { View, Dialog } from "../base";
import { ErrorFallbackConfigForm, ErrorFallbackConfigFormData } from "./ErrorFallbackConfigForm";

type ErrorFallbackSettingsDialogProps = {
  isOpen: boolean;
  onClose: () => void;
  config: ErrorFallbackConfigFormData;
  onChange: (key: string) => (value: unknown) => void;
};

export const ErrorFallbackSettingsDialog = ({ isOpen, onClose, config, onChange }: ErrorFallbackSettingsDialogProps) => {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title="Error Fallback Settings"
      size="flex"
      className="w-full max-w-[600px] min-w-0 max-h-[90vh] mx-4"
    >
      <View className="p-4 sm:p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
        <ErrorFallbackConfigForm
          config={config}
          onChange={onChange}
        />
      </View>
    </Dialog>
  );
};
